import { render, staticRenderFns } from "./ShareLandingNew.vue?vue&type=template&id=08a5e826&scoped=true"
import script from "./ShareLandingNew.vue?vue&type=script&lang=js"
export * from "./ShareLandingNew.vue?vue&type=script&lang=js"
import style0 from "./ShareLandingNew.vue?vue&type=style&index=0&id=08a5e826&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5e826",
  null
  
)

export default component.exports